import React from "react";
import { Carousel, Modal } from "react-bootstrap";
import { API_URLS } from "../../../configs/api.urls";

const ImageModal = (props) => {
  const [index, setIndex] = React.useState(0);

  const handleSelect = (selectedIndex, e) => {
    setIndex(selectedIndex);
  };

  const getImageSrc = (item) => {
    if (props?.type === "marks") {
      return `${API_URLS.ASSETS_BACKEND_URL}/${item.imagePath}`;
    } else return `${API_URLS.ASSETS_BACKEND_URL}/${item}`;
  };
  return (
    <Modal
      show={props.show}
      dialogClassName="modal-50w modal-70h"
      onHide={props.toggleModal}
      aria-labelledby="Inspection Images"
    >
      <Modal.Header closeButton>{props?.title}</Modal.Header>
      <Modal.Body
        className="show-grid mx-2"
        style={{ objectFit: "contain", overflow: "scroll" }}
      >
        <Carousel
          nextIcon={
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="#1d4ed8"
              className="big-icon"
            >
              <path
                fillRule="evenodd"
                d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25Zm4.28 10.28a.75.75 0 0 0 0-1.06l-3-3a.75.75 0 1 0-1.06 1.06l1.72 1.72H8.25a.75.75 0 0 0 0 1.5h5.69l-1.72 1.72a.75.75 0 1 0 1.06 1.06l3-3Z"
                clipRule="evenodd"
              />
            </svg>
          }
          prevIcon={
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="#1d4ed8"
              className="big-icon"
            >
              <path
                fillRule="evenodd"
                d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25Zm-4.28 9.22a.75.75 0 0 0 0 1.06l3 3a.75.75 0 1 0 1.06-1.06l-1.72-1.72h5.69a.75.75 0 0 0 0-1.5h-5.69l1.72-1.72a.75.75 0 0 0-1.06-1.06l-3 3Z"
                clipRule="evenodd"
              />
            </svg>
          }
          defaultActiveIndex={props.activeIndex}
          slide={false}
          onSelect={handleSelect}
          interval={null}
          style={{ backgroundColor: "#1d4ed830" }}
        >
          {props?.photos?.map((item, index) => (
            <Carousel.Item key={index} style={{ height: "70vh" }}>
              <img
                style={{
                  height: "100%",
                  width: "auto",
                }}
                className="mx-auto my-auto"
                src={getImageSrc(item)}
                alt="photo from inspection report"
                onError={(event) => {
                  event.target.src =
                    "https://img.icons8.com/parakeet-line/48/remove-image.png";
                  event.onerror = null;
                  event.target.style = {
                    height: "100px",
                    width: "auto",
                  };
                }}
              />
              {props?.type == "marks" && (
                <Carousel.Caption
                  className="p-2 rounded"
                  style={{ backgroundColor: "#1e3a8a90" }}
                >
                  <div className="d-flex align-items-center justify-content-between">
                    <h3 className="text-white text-capitalize h5">
                      {item.markType}
                    </h3>
                    <h3 className="text-white text-capitalize h5">
                      Side:{"  "}
                      {item?.side}
                    </h3>
                  </div>
                  {item.description === ("" || null) ? (
                    <p className="text-light text-left font-italic">
                      No Description
                    </p>
                  ) : (
                    <p className="text-left">{item.description}</p>
                  )}
                </Carousel.Caption>
              )}
            </Carousel.Item>
          ))}
        </Carousel>
      </Modal.Body>
    </Modal>
  );
};

export default ImageModal;
